import styles from './SaleTag.module.scss'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faTag,
} from '@fortawesome/pro-solid-svg-icons'

const SaleTag = (props) => {
  if (`${props.special_amount}` !== "null") {
		return (
			<div className={`${styles.tag} ${props.className}`}>
					<FontAwesomeIcon className={styles.icon} icon={faTag} />
					{props.special_amount}
			</div>
		)
	}
}
 
export default SaleTag;

